<template>
    <b-form-group :label="label" label-for="referenceType">
        <Select
            id="referenceType"
            :state="state"
            :selected="value"
            :options="referenceTypes"
            @changeValue="$emit('update:value', $event)"
            aria-describedby="referenceTypeFeedback"
            :disabled="disabled"
        />
        <b-form-invalid-feedback id="referenceTypeFeedback">
            <slot />
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
import { Select } from '@/views/components/selects'
import defaultReferenceTypes from '@/data/target-reference-types'
import api from '@/services/api'

export default {
    name: 'ReferenceType',
    components: {
        Select,
    },
    props: ['value', 'state', 'label', 'disabled'],
    data() {
        return {
            referenceTypes: defaultReferenceTypes,
        }
    },
    mounted() {
        api.get(`goals/${this.$route.params.targetId}/get-reference-type`)
            .then(resp => {
                const referenceType = resp.data.data
                if (referenceType) {
                    this.$emit(
                        'update:value',
                        this.mapperToSelect(referenceType)
                    )
                } else {
                    const defaultOption = this.referenceTypes.find(
                        option => option.isDefault
                    )
                    this.$emit('update:value', defaultOption)
                }
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$emit('ready', true)
            })
    },
    methods: {
        mapperToSelect(referenceTitle) {
            return this.referenceTypes.find(
                reference => reference.value == referenceTitle
            )
        },
    },
}
</script>
